// Global constants
export const LOAD_FILE = "uptData/LOAD_FILE";
export const SAVE_FILE = "uptData/SAVE_FILE";
export const CHANGE_FILE_NAME = "uptData/CHANGE_FILE_NAME";
export const LOAD_FILE_DIALOG = "uptData/LOAD_FILE_DIALOG";
export const EDIT_VALUES = "uptData/EDIT_VALUES";
export const CREATE_NEW_FILE = "uptData/CREATE_NEW_FILE";
export const ADD_DRIVE = "uptData/ADD_DRIVE";
export const REMOVE_DRIVE = "uptData/REMOVE_DRIVE";
export const MOVE_DRIVES = "uptData/MOVE_DRIVES";
export const INSERT_PICKS = "uptData/INSERT_PICKS";
export const REMOVE_PICKS = "uptData/REMOVE_PICKS";
export const REMOVE_PICKS_FROM_SELECTION =
  "uptData/REMOVE_PICKS_FROM_SELECTION";
export const TOGGLE_JACQUARD_DATA = "uptData/TOGGLE_JACQUARD_DATA";
export const TOGGLE_SHAFT_DATA = "uptData/TOGGLE_SHAFT_DATA";
export const TOGGLE_REGULATOR = "uptData/TOGGLE_REGULATOR";
export const TOGGLE_COLOR_CONTROL_DATA = "uptData/TOGGLE_COLOR_CONTROL_DATA";
export const EDIT_SHAFT_JACQUARD = "uptData/EDIT_SHAFT_JACQUARD";
export const FILE_MODIFIED = "uptData/FILE_MODIFIED";

// Local constants
export const SET_DATA = "SET_DATA";
export const SET_DATA_AVAILABLE = "SET_DATA_AVAILABLE";
export const SET_AVAILABLE_FILES = "SET_AVAILABLE_FILES";
export const SET_EDIT_VALUES = "SET_EDIT_VALUES";
export const RESET_STATE = "RESET_STATE";
export const FILE_SAVED = "FILE_SAVED";
export const SET_MODIFIED = "SET_MODIFIED";
export const INSERT_PICKS_MUTATION = "INSERT_PICKS_MUTATION";
export const REMOVE_PICKS_MUTATION = "REMOVE_PICKS_MUTATION";
export const SET_FILE_NAME = "SET_FILE_NAME";
export const SET_FILE_TYPE = "SET_FILE_TYPE";
export const SET_EDITABLE = "SET_EDITABLE";
export const SET_JACQUARD_DATA = "SET_JACQUARD_DATA";
export const SET_SHAFT_DATA = "SET_SHAFT_DATA";
export const SET_SHAFT_JACQUARD = "SET_SHAFT_JACQUARD";
export const SET_REGULATOR = "SET_REGULATOR";
export const SET_CPPP = "SET_CPPP";
